import React, { createContext, useCallback, useContext, useState } from 'react';

const ToastContext = createContext(null);

const TOAST_DURATION = 3200;

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  const addToast = useCallback((message, type = 'info') => {
    const id = `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    setToasts((prev) => [...prev, { id, message, type }]);
    setTimeout(() => removeToast(id), TOAST_DURATION);
  }, [removeToast]);

  return (
    <ToastContext.Provider value={{ addToast }}>
      {children}
      <div className="fixed top-4 right-4 z-50 space-y-2 pointer-events-none">
        {toasts.map((toast) => (
          <div
            key={toast.id}
            className={`pointer-events-auto rounded-lg px-4 py-3 shadow-lg border ${
              toast.type === 'error'
                ? 'bg-red-900/80 border-red-500/40 text-red-100'
                : toast.type === 'success'
                  ? 'bg-emerald-900/80 border-emerald-500/40 text-emerald-50'
                  : 'bg-slate-800/90 border-cyan-500/30 text-cyan-50'
            }`}
          >
            <p className="text-sm font-semibold">{toast.message}</p>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);
